import { useEffect } from "react";
import { Navigate, Route, Routes } from "react-router-dom";

import { useMessenger } from "@/app/hooks/use-messenger";
import { CoachingHub } from "@/features/coaching/screens";
import { ROUTES } from "../constants";
import { PortalRoutesWrapper } from "./portal-routes-wrapper";

export const CoachingUserRouter = () => {
  const {
    actions: { showMessenger },
  } = useMessenger();

  useEffect(() => {
    showMessenger();
  }, [showMessenger]);

  return (
    <Routes>
      <Route element={<PortalRoutesWrapper />}>
        <Route path={ROUTES.COACHING.OVERVIEW} element={<CoachingHub />} />
      </Route>

      <Route path="*" element={<Navigate replace to={ROUTES.BASE} />} />
    </Routes>
  );
};
